<template>
  <div class="clear" />
  <div class="middle">
    <div class="cont">
      <h1 class="pageTitle">事業内容</h1>
      <div class="lbox2">
        <a href="/service" class="menuBtn">Webサイト構築</a>
        <a href="/service2" class="menuBtn">管理システム構築</a>
        <div class="menuBtnActive">ECパッケージAjax版</div>
      </div>
      <div class="rbox2">
        <div class="chapt clear">
          <table>
            <tr>
              <th><a name="t01">ECパッケージAjax版</a></th>
            </tr>
            <tr>
              <td>
                <ul>
                  <li>
                    特徴はWEBページの遷移行わず、１ページで商品検索、商品詳細参照等はできること。
                  </li>
                </ul>
              </td>
            </tr>
          </table>
          <!--
		 		<table>
		 			<tr>
		 				<th><a name="t01">ECパッケージAjax版デモ</a></th>
		 			</tr>
		 			<tr>
		 				<td>
		 					<ul>
		 						<li><a href="/HS/" target="_blank">ECパッケージAjax版へのリンク</a></li>
		 						<li><a href="/HS/admin" target="_blank">ECパッケージAjax版管理画面へのリンク</a></li>
		 						<li>弊社ECパッケージAjax版の特徴を説明するためのデモです。</li>
                <li>デモ版は一部しか実装しておりませんが、お客様が要求する機能を技術的可能な限りいつでも実装できます。</li>
		 						<li>画面デザインはサンプルです、お客様要求するデザインに変えることができます。</li>
		 					</ul>
		 				</td>
		 			</tr>
		 		</table>
                                -->
          <table>
            <tr>
              <th>メリット１：１ページ内で一覧結果と商品詳細情報同時表示</th>
            </tr>
            <tr>
              <td>
                <ul>
                  <li>
                    通常のWEBサイトは商品一覧ページで商品詳細リンクをクリックすると、商品詳細画面へ遷移し、詳細画面からまた一覧画面へ戻った場合、一覧ページの最初から表示しなおされます。そのため前回見た位置までスクロールして、次の商品を探す手間が発生します。
                  </li>
                  <li>
                    弊社のECパッケージでは、商品一覧と商品詳細情報をそれぞれ１ページ中の別のタブに表示することより、一覧の操作状態がそのまま保持されます。そのためスクロールして次の商品を探す手間がなくなります。
                  </li>
                </ul>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <th>
                <a name="t01"
                  >メリット２：１ページ内で複数の商品詳細情報同時表示</a
                >
              </th>
            </tr>
            <tr>
              <td>
                <ul>
                  <li>
                    通常のWEBサイトは、複数商品比較機能を提供しない限り、一回で１商品の詳細情報しか参照できません。
                  </li>
                  <li>
                    弊社のECパッケージでは、異なる複数の商品詳細情報を１ページ中の複数のタブにそれぞれ表示することより、複数の商品情報を同時に表示し、比較することができます。
                  </li>
                </ul>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <th>
                <a name="t01"
                  >メリット３：カテゴリの階層ツリーはいつでも表示される</a
                >
              </th>
            </tr>
            <tr>
              <td>
                <ul>
                  <li>
                    通常のWEBサイトは、サイドメニューで商品カテゴリの階層表示しないため(通常はトップ階層のみを表示)、カテゴリページにを表示させ、サブカテゴリページから検索を行う手間が発生します。
                  </li>
                  <li>
                    弊社のECパッケージでは、サイドメニューで常に商品カテゴリ階層ツリーを表示することより、任意のページ（一覧ページや詳細ページ）から直接調べたいカテゴリの検索結果を表示させることができます。
                  </li>
                </ul>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <th>
                <a name="t01"
                  >メリット４：カテゴリと規格(アパレルの場合はサイズ情報)</a
                >
              </th>
            </tr>
            <tr>
              <td>
                <ul>
                  <li>
                    弊社のECパッケージでは、カテゴリ毎に規格設定することができます。
                  </li>
                  <li>
                    例えば、Tシャツの場合は「着丈、肩幅、身幅、そで丈」で採寸規格を設定できますし、パンツの場合は「ウエスト、股上、股下、すそ周り、ヒップ」で採寸規格を設定できます。
                  </li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <br class="clear" />
    </div>
  </div>
</template>
<script>
export default {
  setup() {},
};
</script>
